import type { BankConnectSchema } from "bankconnect";

import { BankConnectContext } from "./use-bank-connect-context";

export const BankConnectContextProvider = ({
  bankConnectSchema,
  children,
}: {
  bankConnectSchema: BankConnectSchema;
  children?: React.ReactNode;
}) => {
  return <BankConnectContext.Provider value={bankConnectSchema}>{children}</BankConnectContext.Provider>;
};
